import classNames from "classnames";
import React, { PureComponent } from "react";

import { ITestable, testAttr } from "@/browser";

import { IStyleColor, IStyleSize, IStyleTheme } from "../Style";

export type TColor = "primary" | "secondary" | "light" | "link" | "warning" | "danger";
type TTheme = "outline";

type Styles = IStyleSize & IStyleColor<TColor> & IStyleTheme<TTheme>;

export interface IBadgeProps extends Partial<Styles>, ITestable {
  /**
   * Bold the badge font
   * @default undefined
   */
  bold?: boolean;

  /**
   * Adds border to badge
   * @default undefined
   */
  border?: boolean;

  /**
   * For extend class names
   * @default undefined
   */
  className?: string;

  /**
   * Monospace font on badge
   * @default undefined
   */
  mono?: boolean;

  /**
   * Round border on badge - more than border radius
   * @default undefined
   */
  round?: boolean;
}

/**
 * Badge component can be used for display system id's or some identificator numbers
 * @see Badge extends also [ISize](#types--interfaces) styles interface by pass **size** param
 */
export class Badge extends PureComponent<IBadgeProps> {
  static defaultProps = {
    size: "md",
    mono: true,
  };

  render() {
    const { bold, border, children, className, color, size, round, theme, mono } = this.props;

    const classes = classNames(
      "el-badge",
      {
        [`el-badge--color-${color}`]: !!color,
        [`el-badge--theme-${theme}`]: !!theme,
        [`el-badge--size-${size}`]: !!size,
        "el-badge--mono": !!mono,
        "el-badge--bold": !!bold,
        "el-badge--round": !!round,
        "el-badge--border": !!border,
      },
      className,
    );

    return (
      <span className={classes} {...testAttr(this.props, { sufix: "badge" })}>
        {children}
      </span>
    );
  }
}

export default Badge;
